<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-06-29 16:27:26
 * @LastEditTime: 2022-02-24 22:00:37
 * @LastEditors: chenguobiao
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { authorizationFormat, clearLoginStatus } from '@/render/utils'
import { homeAPI } from '@/apis'
export default {
  name: 'App',
  components: {},
  props: {},
  data() {
    return {
      _beforeUnload_time: 0,
      _gap_time: 0,
    }
  },
  computed: {},
  created() {
    // const { code } = this.$route.query
    // if (code) this.getLoginSource()
  },
  mounted() {
    // this.handleUserLogout()
    // this.handleCloseBrowser()
  },
  //当用户离开此界面时执行（销毁事件）
  destroyed() {
    //删除  当页面卸载（关闭）或刷新时调用事件
    // window.removeEventListener('beforeunload', (e) =>
    //   this.beforeunloadHandler(e),
    // )
    //删除 当用户离开页面时调用事件
    // window.removeEventListener('unload', (e) => this.handleClose(e))
  },
  methods: {
    // async handleUserLogout() {
    //   const token = this.$store.getters['auth/token']
    //   clearLoginStatus()
    //   await fetch('/api/login/testUserLogout', {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json;charset=utf-8',
    //       token: authorizationFormat(token),
    //     },
    //     keepalive: true,
    //   })
    // },
    // async handleClose() {
    //   this._gap_time = new Date().getTime() - this._beforeUnload_time
    //   if (this._gap_time <= 5) {
    //     this.handleUserLogout()
    //   }
    // },
    // handleCloseBrowser() {
    //   //添加事件  当页面卸载（关闭）或刷新时调用
    //   window.addEventListener('beforeunload', async (e) =>
    //     this.beforeunloadHandler(),
    //   )
    //   //添加事件 当用户离开页面时调用
    //   window.addEventListener('unload', (e) => this.handleClose())
    //   // this.handleClose()
    // },
    // beforeunloadHandler() {
    //   this._beforeUnload_time = new Date().getTime()
    // },
  },
}
</script>

<style lang="scss">
/* img {
  width: 100%;
} */
.el-popover {
  &.home_userinfo_popper-class {
    margin: 0;
    padding: val(29) val(21) val(28);
    top: val(75) !important;
    min-width: unset;
    width: val(162);
    // height: val(123);
    background: url('./assets/images/header/popper_bg.png') no-repeat left top;
    background-size: cover;
    border: none;
    box-shadow: unset;
    box-sizing: border-box;
    z-index: 99999 !important;
    .popper__arrow {
      display: none;
    }
  }

  &.start_game_popper-class {
    background-color: var(--dialog-bg-color);
    border: 1px solid var(--dialog-border-color);
    border-radius: val(15);
    padding: val(40);
    .popper__arrow {
      display: none;
    }
  }
}

.el-message {
  padding: 15px;
  &__icon {
    font-size: 16px;
  }
}
.page-normal {
  display: flex;
  flex-direction: column;
  height: 100vh;
  &__content {
    // flex: 1;height: val(125);
    position: relative;
    height: calc(100vh - 1.25rem);
    background: url('./assets/images/grading/bg.png') repeat left top;
    background-size: cover;
    .title {
      display: flex;
      justify-content: space-between;
      margin-bottom: val(66);
      .left-main {
        display: flex;
        align-items: center;
        font-size: val(24);
        font-weight: 500;
        color: #4e2500;
        .line-bar {
          margin-right: val(5);
          width: val(6);
          height: val(16);
          background-color: #4e2500;
        }
      }
      .right-back {
        font-size: val(18);
        line-height: val(32);
        color: #0077e8;
        cursor: pointer;
      }
    }
    &__box {
      margin: val(77) auto 0;
      width: val(1500);
      height: val(800);
      background-color: #fff;
      box-shadow: 0px 13px 35px rgba(0, 0, 0, 0.14);
      border-radius: val(15);
    }
  }
}


</style>
